export const DefaultPagination = (limit: any): any => ({
  offset: 1,
  lastOffset: 0,
  limit,
  total: 0,
});
